import React from "react";
// import CarlsbergVideo from "../assets/videos/CarlsbergVideo.mp4"
// import CarlsbergPoster from "../assets/images/CarlsbergWork.webp"

function Carlsberg() {
  const [isMuted, setIsMuted] = React.useState(true);
  return (
    <div className="w-full h-full bg-black">
      <div className="w-full h-[50vh] sm:h-[60vh] md:h-[100vh] flex items-center justify-between relative">
        {/* <div className="hidden lg:block h-[40vh] sm:h-[50vh] md:h-[60vh] w-12 sm:w-16 md:w-24">
            <LogoMarquee direction="vertical" />
          </div> */}
        {/* <video
          src={CarlsbergVideo}
          autoPlay
          muted={isMuted}
          loop
          playsInline
          className="w-full h-full object-cover"
          preload="auto"
          poster={CarlsbergPoster}
        /> */}
        <button
          onClick={() => setIsMuted(!isMuted)}
          className="absolute bottom-4 right-4 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-all duration-300"
        >
          {isMuted ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
              />
            </svg>
          )}
        </button>
        {/* <div className="hidden lg:block h-[40vh] sm:h-[50vh] md:h-[60vh] w-12 sm:w-16 md:w-24">
            <LogoMarquee direction="vertical" verticalDirection="down" />
          </div> */}
      </div>
    </div>
  );
}

export default Carlsberg;
